module.exports = __webpack_public_path__ + "static/media/create-en.01c690d9.png";